import React from 'react';
import PropTypes from 'prop-types';
import {
  Bar,
  BarChart,
  Label,
  LabelList,
  Tooltip,
  XAxis,
  YAxis
} from 'recharts';
import { BarChartHOC } from './barChartUtil';
import { formatDecimal } from '../../util';

const CustomerTooltip = (props) => {
  const { active = true, payload, isNs } = props;
  const customerInfo =
    (Array.isArray(payload) && payload.length > 0 && payload[0].payload) ||
    null;
  if (customerInfo) {
    const { customer, name } = customerInfo;
    const { alertType, type } = customer || {};
    if (active) {
      return BarChartHOC(customer, isNs, alertType, name, type);
    }
    return null;
  }
  return null;
};

const CustomerModal = (props) => {
  const { customer, name } = props.props;
  const { onClick, isNs } = props;
  const { alertType, type } = customer || {};

  return BarChartHOC(customer, isNs, alertType, name, type, onClick);
};

const CustomizedAxisTick = (props) => {
  const { x, y, stroke, payload } = props;

  return (
    <g transform={`translate(${x},${y})`}>
      <text
        style={{ fontSize: '8px', textOverflow: 'ellipsis', width: '10px' }}
        x={0}
        y={0}
        dy={12}
        textAnchor="end"
        fill="#666"
        transform="rotate(-30)">
        {payload.value}
      </text>
    </g>
  );
};

class CustomerBarChart extends React.Component {
  static propTypes = {
    width: PropTypes.number,
    height: PropTypes.number,
    data: PropTypes.array,
    segment: PropTypes.string,
    dataKey: PropTypes.string,
    xDataKey: PropTypes.string
  };

  constructor(props) {
    super(props);
    this.state = {
      isClicked: false,
      customerModalProps: {}
    };
  }

  toggleClick = (props) => {
    // console.log(props)
    this.setState({
      isClicked: !this.state.isClicked,
      customerModalProps: props
    });
  };

  render() {
    const {
      data,
      dataKey,
      xDataKey,
      width,
      height,
      yLabel,
      fill,
      isNs
    } = this.props;
    const { isClicked } = this.state;
    if (!data || !dataKey || !xDataKey) {
      return <div />;
    }

    let biggestAlertCount = 0;
    data.map((o) => {
      if (biggestAlertCount < o.alertCount) {
        biggestAlertCount = o.alertCount;
      }
    });

    const barFill = fill ? fill : '#432ff3';

    return (
      <div
        style={{
          marginTop: '20px',
          marginLeft: '-20px',
          height: '400px',
          paddingLeft: '45px'
        }}>
        <BarChart
          width={width || 0}
          height={height || 0}
          data={data}
          margin={{ top: 10, right: 20, left: 20, bottom: 100 }}>
          >
          <defs>
            <linearGradient id="customersView" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor={barFill} stopOpacity={0.75} />
              <stop offset="95%" stopColor={barFill} stopOpacity={0} />
            </linearGradient>
          </defs>
          <XAxis
            dataKey={xDataKey}
            interval={0}
            tick={<CustomizedAxisTick />}
          />
          <YAxis
            type="number"
            domain={[0, (dataMax) => Math.ceil(dataMax * 1.05)]}>
            <Label
              dy={30}
              dx={0}
              angle={-90}
              value={yLabel || ''}
              position="insideLeft"
            />
          </YAxis>
          {!isClicked && <Tooltip content={<CustomerTooltip isNs={isNs} />} />}
          <Bar
            onClick={this.toggleClick}
            dataKey={dataKey}
            fill="url(#customersView)">
            <LabelList dataKey={dataKey} position="top" />
          </Bar>
        </BarChart>
        {isClicked && (
          <div
            style={{
              position: 'absolute',
              width: '50%',
              top: '0',
              left: '25%'
            }}>
            <CustomerModal
              onClick={this.toggleClick}
              isNs={isNs}
              props={this.state.customerModalProps}
            />
          </div>
        )}
      </div>
    );
  }
}

export default CustomerBarChart;
